import React from 'react'
import CoomingSoon from '../Components/CoomingSoon/CoomingSoon'
import TopBar from '../Components/TopBar/TopBar'

const CommingSoonPage = () => {
  return (
    <>
    <TopBar/>
    <CoomingSoon/>
    </>
  )
}

export default CommingSoonPage